module.exports = __webpack_public_path__ + "media/live-session/streamlabs-setup-6638cabb.png";